import {combineReducers} from "redux"
import {isEmpty} from "lodash"
import types from "actions/types"

export const allRevisions = (state = [], action) => {
  switch (action.type) {
    case types.QUOTING_LOAD_APPROVAL_SUCCESS:
    case types.QUOTING_UPDATE_APPROVAL_SUCCESS:
      if (!isEmpty(action.allRevisions)) return action.allRevisions
      return action.updatedRevision ? [action.updatedRevision] : []
    case types.QUOTING_ADD_APPROVAL_REVISION_SUCCESS:
      return [
        ...state,
        action.data,
      ]
    default:
      return state
  }
}

export const isLoadingDocuments = (state = false, action) => {
  switch (action.type) {
    case types.LOAD_APPROVAL_REVISION_DOCUMENTS_ATTEMPT:
      return true
    case types.LOAD_APPROVAL_REVISION_DOCUMENTS_SUCCESS:
    case types.LOAD_APPROVAL_REVISION_DOCUMENTS_FAILURE:
      return false
    default:
      return state
  }
}

export const isOpen = (state = false, action) => {
  switch (action.type) {
    case types.QUOTING_SHOW_APPROVAL_REVISIONS_DRAWER:
      return true
    case types.QUOTING_HIDE_APPROVAL_REVISIONS_DRAWER:
      return false
    default:
      return state
  }
}

export const selectedRevisionDocuments = (state = [], action) => {
  switch (action.type) {
    case types.LOAD_APPROVAL_REVISION_DOCUMENTS_SUCCESS:
      return action.data
    default:
      return state
  }
}

export default combineReducers({
  allRevisions,
  isLoadingDocuments,
  isOpen,
  selectedRevisionDocuments,
})
